// extracted by mini-css-extract-plugin
export default {"wrapper":"RoundInitialsButton_wrapper__GWQDL"};